<br />
<img
    class="system-logo"
    src="assets/images/logos/tms-main.png"
/>
<br />
<div class="forgot-password-container clearfix">
    @if (!checkEmail) {
        <form
            (ngSubmit)="onSubmit()"
            [formGroup]="forgotPasswordForm"
        >
            <h2>Forgot Password</h2>
            <div class="row">
                <pcg-control-group
                    class="col-sm-12"
                    label="Email"
                >
                    <input
                        pcgControlRef
                        formControlName="email"
                        type="text"
                        class="form-control email"
                    />
                </pcg-control-group>
            </div>
            <button
                type="submit"
                class="btn btn-secondary btn-lg"
            >
                Send Email
            </button>
        </form>
    }
    @if (checkEmail) {
        <div>
            <h2>Forgot Password Confirmation</h2>
            <p>Please check your email to reset your password</p>
        </div>
    }
    <a
        class="float-right"
        routerLink="/login"
    >
        Back to Login
    </a>
</div>
